import useScript from '../../lib/hooks/useScript';

const withCJPublisherTag =
  (Component) =>
  // eslint-disable-next-line react/prop-types
  ({ isCJRedirect = true, ...props }) => {
    if (isCJRedirect) {
      useScript('https://www.p.zjptg.com/tag/2929746/100001');
    }
    return <Component {...props} />;
  };

export default withCJPublisherTag;
